import PermeatorCore from 'permeator-core';

import Top from './permeator/top';
import SoucheMenuDashBoard from './permeator/souche-menu-dashboard';
import SrpMain, { envTest as SrpMainEnvTest } from './permeator/srp-main';

import PermeatorExt, { VueExt } from './PermeatorExt';
import fromSMP from './fromSMP';
import { logMR, isTop } from '../util';
import msg from '../message/index';

const { version } = require('../../package.json');

const menuRouter: PermeatorExt = new PermeatorCore('SMP/MR', {
    logger: logMR,
    async beforeReady() {
        logMR('我是菜单伴侣子页面菜单路由, 负责通知父页面跳转或打开新页面');
        logMR(`SMP version: ${version}`);
        return menuRouter.$getOpenPayload();
    }
});

/** 监听所有信息 */
const entry = (e: any) => {
    if (e.data && msg.has(e.data.$type)) {
        logMR(`receive ${e.data && e.data.$type || '未知类型消息'}, 已分发处理`);
    } else {
        logMR(`receive ${e.data && e.data.$type || '未知类型消息'}, 但是未处理`, e.data, e);
    }
};

window.addEventListener('message', entry);

/*
    interface 接口, 传入字符串数组, 字符串为方法名, 表示 menuRouter 将继承各平台的该方法
    在 $use 各平台 extends / permeator 中声明的方法, 在其他平台中使用可能会因没有此方法导致报错
    在 $interface 中声明后, 如果该平台没有实现该方法, 仅在控制台中显示警告
 */
menuRouter.$interface([
    '$getOpenPayload',
    'getSelectedShop', 'getAuthZ',
    'title',
    'push', 'replace', 'open', 'close', 'onClose'
]);

/*
    use 使用, 传入对象, 用于方便扩展平台
    - name 名称, 字符串, 用于 isXx()/inXx() 等方法名
    - globalVar 全局变量, 字符串, window.xx 全局变量名
    - jsPath js 路径, 字符串, 用于加载远程依赖
    - loadCondition 加载条件, 函数, 用于判断是否加载远程依赖
    - entTest 环境判断, 函数, 回调环境判断结果
    - extends 扩展, 字符串数组, 字符串为方法名, 扩展该平台的该方法到 menuRouter
    - permeator 连通器, https://baike.baidu.com/item/连通器/1534580
        通过连通器, 使得各平台小程序 api 表现效果一致
 */

// https://git.souche-inc.com/new-retail-wireless/srp-main
menuRouter.$use({
    name: 'SrpMain',
    envTest: () => SrpMainEnvTest(),
    permeator: SrpMain
});

// @souche-ui/souche-menu-dashboard
// - http://npm.souche-inc.com/package/@souche-ui/souche-menu-dashboard
menuRouter.$use({
    name: 'SoucheMenuDashBoard',
    envTest: () => Promise.resolve(!isTop() && !fromSMP()),
    permeator: SoucheMenuDashBoard
});

/*
    setRollBack 回滚, 传入对象, 用于不在任何平台下的默认执行
    - permeator 连通器, 使得回滚 api 表现与各平台效果一致
 */
menuRouter.$setRollBack({
    name: 'top',
    permeator: Top
});

menuRouter.install = (Vue: VueExt, { router }:any = {}) => {
    Vue.$menuRouter = menuRouter;
    Vue.prototype.$menuRouter = menuRouter;

    if (router) {
        router.beforeEach((to, from, next:Function) => {
            menuRouter.ready(() => {
                next();
            });
        });
    }
};

export default menuRouter;
